export function disableImplicitFallback(fallback: string) {
  // https://kazupon.github.io/vue-i18n/guide/fallback.html#implicit-fallback-using-locales
  return fallback + '!'
}
